/**
 * Dynamic Content Security Policy configuration
 * Sets CSP based on environment variables
 */

export function initializeCSP() {
  // Get API base URL from environment
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  
  if (!apiBaseUrl) {
    console.error('REACT_APP_API_BASE_URL environment variable is required');
    return;
  }

  // Extract domain from API URL
  let apiDomain;
  try {
    const url = new URL(apiBaseUrl);
    apiDomain = url.origin;
  } catch (error) {
    console.error('Invalid API base URL provided');
    return;
  }
  
  // Build CSP directives
  const cspDirectives = [
    "default-src 'self'",
    "script-src 'self' 'unsafe-inline' https://www.googletagmanager.com https://www.google-analytics.com https://www.clarity.ms https://*.clarity.ms",
    "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com",
    "font-src 'self' https://fonts.gstatic.com",
    "img-src 'self' data: https: https://www.clarity.ms https://*.clarity.ms",
    `connect-src 'self' ${apiDomain} https://api.openalex.org https://www.google-analytics.com https://www.clarity.ms https://*.clarity.ms https://c.clarity.ms`,
    "frame-ancestors 'none'",
    "base-uri 'self'",
    "form-action 'self'"
  ];
  
  const cspContent = cspDirectives.join('; ');
  
  // Create or update CSP meta tag
  let cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  if (!cspMeta) {
    cspMeta = document.createElement('meta');
    cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
    document.head.appendChild(cspMeta);
  }
  
  cspMeta.setAttribute('content', cspContent);
  
}

/**
 * More restrictive CSP for production
 */
export function initializeProductionCSP() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  
  if (!apiBaseUrl) {
    console.error('REACT_APP_API_BASE_URL is required in production');
    return;
  }
  
  let apiDomain;
  try {
    const url = new URL(apiBaseUrl);
    apiDomain = url.origin;
  } catch (error) {
    console.error('Invalid API base URL in production');
    return;
  }
  
  // Stricter CSP for production (remove 'unsafe-inline' if possible)
  const cspDirectives = [
    "default-src 'self'",
    "script-src 'self' https://www.googletagmanager.com https://www.google-analytics.com https://www.clarity.ms https://*.clarity.ms",
    "style-src 'self' https://fonts.googleapis.com",
    "font-src 'self' https://fonts.gstatic.com",
    "img-src 'self' data: https: https://www.clarity.ms https://*.clarity.ms",
    `connect-src 'self' ${apiDomain} https://api.openalex.org https://www.google-analytics.com https://www.clarity.ms https://*.clarity.ms https://c.clarity.ms`,
    "frame-ancestors 'none'",
    "base-uri 'self'",
    "form-action 'self'",
    "upgrade-insecure-requests"
  ];
  
  const cspContent = cspDirectives.join('; ');
  
  let cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  if (!cspMeta) {
    cspMeta = document.createElement('meta');
    cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
    document.head.appendChild(cspMeta);
  }
  
  cspMeta.setAttribute('content', cspContent);
  
}